import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${sizes.medium} 0;
`;

export {LoadingWrapper};
